import React from 'react';
import { FluentDatePicker } from '../../../../../components/FluentUI/Fluent-DatePicker';
import { makeStyles, shorthands } from '@fluentui/react-components';
import { setTimeToZero } from '../../../../../util/time-helpers';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  root: {
      display: "flex",
      padding: "5px",
      ...shorthands.border("1px", "solid", "#EEEEEE"),
      resize: "vertical !important",
      fontSize: "12px !important",
      color: "#4E4E4E",
      height: "36px",
      marginTop: "6px",
  },
});

function ProjectEndDate({
    handleChange,
    minDate,
    endDate,
    errors
}) {
  const fieldStyle = useStyles();

  const sanitizedMinDate = setTimeToZero(minDate);
  const sanitizedEndDate = setTimeToZero(endDate);

  return (
    <FluentDatePicker 
        label="End Date"
        placeholder="Select a Date"
        required={true}
        size="small"
        minDate={sanitizedMinDate}
        value={sanitizedEndDate}
        onChange={(date) => {handleChange('End', date);}}
        componentStyle={fieldStyle.root}
        validationMessage={errors}
    />
  )
}

ProjectEndDate.propTypes = {
    handleChange: PropTypes.func.isRequired,
    endDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    errors: PropTypes.string
}


export default ProjectEndDate